<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >

        </el-form>

        <el-table :data="SumDailyList" stripe border center :size="GCONFIG.styleTableSize" v-show="!showDialog">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="sTime" label="日期"></el-table-column>
            <el-table-column prop="sumTotal" label="总额"></el-table-column>
            <el-table-column prop="sumStore" label="储值部分"></el-table-column>
            <el-table-column prop="sumGift" label="礼品卡部分"></el-table-column>
            <el-table-column prop="sumFree" label="赠送部分"></el-table-column>
            <el-table-column prop="sumSpecial" label="水牛奶卡部分"></el-table-column>
        </el-table>
        <div class="pagination-wrap" v-show="!showDialog">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {findSumDaily} from '@/api/api';
    export default {
        data() {
            return {
                SumDailyList: [],
                formInline: {
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.findSumDaily();
        },
        methods: {
            findSumDaily(){
                findSumDaily(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.formInline.recordsTotal = res.data.value.total;
                        this.SumDailyList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.findSumDaily();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.findSumDaily();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/storage/SumDaily.vue